import React, { useState, useEffect } from 'react';
import { getMessages, sendMessage, updateMessage, deleteMessage } from '../storage';
import { toast, Btn, Card, NoData } from '../ui.jsx';

// ── Teacher Messages ──────────────────────────────────────────────
function TeacherMessages({ db, teacher }) {
  const [msgs, setMsgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const myClasses = (teacher.cls || '').split(',').map(x => x.trim()).filter(Boolean);
  const myCls = myClasses.join(', ');

  useEffect(() => {
    const all = (db.messages || []).filter(m => myClasses.length === 0 || myClasses.includes(m.cls));
    setMsgs(all.sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || '')));
    setLoading(false);
  }, [db.messages, myCls]);

  const card = (m, i) => {
    const typeColor = { message: '#1960a3', complaint: '#dc2626', query: '#d97706', feedback: '#059669' };
    const typeBg = { message: '#eef4ff', complaint: '#fef2f2', query: '#fef9c3', feedback: '#f0fdf4' };
    const tc = typeColor[m.type] || '#64748b';
    const tb = typeBg[m.type] || '#f8fafc';
    return (
      <div key={m.id || i} style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', border: '1px solid #f1f5f9', boxShadow: '0 1px 6px rgba(0,31,77,0.05)', marginBottom: 10 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,#1960a3,#6366f1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 800, color: '#fff', flexShrink: 0 }}>
              {(m.studentName || '?')[0]}
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#1e293b' }}>{m.studentName || 'Student'}</div>
              <div style={{ fontSize: 10, color: '#94a3b8' }}>Class {m.cls || '—'} · {m.createdAt ? new Date(m.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}</div>
            </div>
          </div>
          <span style={{ fontSize: 10, fontWeight: 700, color: tc, background: tb, padding: '3px 10px', borderRadius: 20, border: `1px solid ${tc}22` }}>{m.type || 'message'}</span>
        </div>
        {m.subject && <div style={{ fontSize: 12, fontWeight: 700, color: '#1e293b', marginBottom: 4 }}>{m.subject}</div>}
        <div style={{ fontSize: 13, color: '#475569', lineHeight: 1.6 }}>{m.body || m.message || ''}</div>
      </div>
    );
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 6 }}>Inbox</div>
        <h1 style={{ fontSize: 28, fontWeight: 900, color: '#1e293b', fontFamily: 'Manrope,sans-serif', margin: 0 }}>Messages</h1>
        {myCls && <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>From Class {myCls} students</div>}
      </div>
      {loading ? <div style={{ textAlign: 'center', padding: '48px', color: '#94a3b8' }}>Loading…</div>
        : msgs.length === 0 ? (
          <div style={{ background: '#fff', borderRadius: 16, padding: '48px 32px', textAlign: 'center', boxShadow: '0 1px 8px rgba(0,31,77,0.06)' }}>
            <span className="material-symbols-outlined" style={{ fontSize: 40, color: '#e2e8f0', display: 'block', marginBottom: 12 }}>mail</span>
            <div style={{ fontSize: 14, color: '#94a3b8', fontWeight: 600 }}>No messages yet</div>
          </div>
        ) : msgs.map(card)
      }
    </div>
  );
}


export default TeacherMessages;
